import { Dialog } from "@kobalte/core/dialog";
import { A } from "@solidjs/router";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbLock, TbX } from "solid-icons/tb";
import { Show, createSignal } from "solid-js";
import { isServer } from "solid-js/web";
import { ProjectSwitcherModal } from "~/components/projects/ProjectSwitcherModal";
import { useWire } from "~/wire";

export const ChatAccessDeniedModal = () => {
  const wire = useWire();
  const isGuest = () => wire.auth.isGuest();
  const isOpen = () => wire.ui.chatAccessDenied.isModalOpen();
  const [isProjectModalOpen, setIsProjectModalOpen] = createSignal(false);
  
  // Don't render on server to avoid hydration issues
  if (isServer) return null;
  
  // Debug logging
  if (isOpen()) {
    console.log("ChatAccessDeniedModal: Modal is open, rendering");
  }
  
  const handleSwitchProjects = () => {
    wire.ui.chatAccessDenied.closeModal();
    setIsProjectModalOpen(true);
  };
  
  return (
    <>
      <AnimateChildren
        show={isOpen()}
        enter={{ opacity: [0, 1], y: [10, 0] }}
        exit={{ opacity: [1, 0], y: [0, 10] }}
      >
        {(anim) => (
          <Dialog
            open={anim.isMounted()}
            onOpenChange={(val) => {
              if (!val) wire.ui.chatAccessDenied.closeModal();
            }}
          >
            <Dialog.Portal>
              <Dialog.Overlay class="fixed z-90 inset-0 bg-black/50 dark:bg-white/10 backdrop-blur-sm" />
              <div ref={anim.ref} class="fixed z-90 inset-0 flex items-center justify-center">
                <Dialog.Content class="max-h-[80vh] relative w-screen text-primary-text max-w-xl bg-panel overflow-y-auto rounded-xl p-8">
                  <Dialog.CloseButton as={StButton} class="absolute top-4 right-4">
                    <TbX />
                  </Dialog.CloseButton>

                  <div class="flex items-center gap-3 mb-6">
                    <TbLock class="w-6 h-6 text-muted-text" />
                    <h3 class="text-lg font-medium">You don't have access to this Project</h3>
                  </div>

                  <Show
                    when={isGuest()}
                    fallback={
                      <>
                        <p class="mb-6 text-sm text-muted-text">
                          Ask the owner of this Project to grant you access.
                        </p>
                        <div class="flex justify-end">
                          <StButton
                            onClick={handleSwitchProjects}
                            class="text-sm px-4 py-2 text-on-brand bg-brand hover:bg-brand-hover"
                          >
                            Switch Projects
                          </StButton>
                        </div>
                      </>
                    }
                  >
                    <p class="mb-6 text-sm text-muted-text">
                      You may need to sign up or login to gain access.
                    </p>
                    <div class="flex items-center gap-2 ml-auto justify-end">
                      <StButton
                        as={A}
                        href="/auth/signup"
                        onClick={() => wire.ui.chatAccessDenied.closeModal()}
                        class="text-sm px-4 py-2 text-on-brand bg-brand hover:bg-brand-hover"
                      >
                        Sign Up
                      </StButton>
                      <span class="text-secondary-text">or</span>
                      <A
                        href="/auth/signin"
                        onClick={() => wire.ui.chatAccessDenied.closeModal()}
                        class="text-sm text-brand hover:text-brand-hover underline font-medium"
                      >
                        Log In
                      </A>
                    </div>
                  </Show>
                </Dialog.Content>
              </div>
            </Dialog.Portal>
          </Dialog>
        )}
      </AnimateChildren>
      
      {/* Project Switcher Modal */}
      <ProjectSwitcherModal open={isProjectModalOpen()} onOpenChange={setIsProjectModalOpen} />
    </>
  );
};

